import React from 'react';
import { Pagination } from 'react-bootstrap';

// Builds a condensed page-number list: 1 ... 4 5 [6] 7 8 ... 20
const buildPageList = (current, total) => {
  const pages = [];
  const windowSize = 1;

  const addPage = (n) => pages.push(n);
  const addEllipsis = () => pages.push('...');

  addPage(1);
  const rangeStart = Math.max(2, current - windowSize);
  const rangeEnd = Math.min(total - 1, current + windowSize);

  if (rangeStart > 2) addEllipsis();
  for (let i = rangeStart; i <= rangeEnd; i++) addPage(i);
  if (rangeEnd < total - 1) addEllipsis();

  if (total > 1) addPage(total);

  return pages;
};

const TablePagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = buildPageList(currentPage, totalPages);

  return (
    <Pagination className="justify-content-center mb-0 mt-3">
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      />
      {pages.map((p, idx) =>
        p === '...' ? (
          <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
        ) : (
          <Pagination.Item
            key={p}
            active={p === currentPage}
            onClick={() => onPageChange(p)}
          >
            {p}
          </Pagination.Item>
        )
      )}
      <Pagination.Next
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      />
    </Pagination>
  );
};

export default TablePagination;
